import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        padding: theme.spacing(2, 3, 3),
        transition: 'transform .3s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)',
        },
    },
    disabled: {
        position: 'relative',
        cursor: 'wait',
        '&:before': {
            content: `''`,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#fff',
            opacity: 0.5,
            zIndex: 2,
        },
    },
    imgWrap: {
        position: 'relative',
        width: '100%',
        height: 250,
        marginBottom: theme.spacing(3),
    },
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    favoriteBtn: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        zIndex: 1,
    },
    link: {
        color: '#222',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    title: {
        fontWeight: 600,
        textTransform: 'uppercase',
        transition: 'color .3s ease',
    },
    newPrice: {
        color: '#cc0514',
        fontSize: 24,
        fontWeight: 600,
        marginBottom: 10,
    },
    oldPrice: {
        color: '#828282',
        textAlign: 'center',
        textDecoration: 'line-through',
    },
}));
